import { REGISTERS_API_URL } from '../constants';
import { type AppDatabase } from '../db';
import type { Terminal } from '../models';
import { retrieveFullPaginatedData } from '../pagination';
import { MONIEPOINT_TERMINAL_USB_ID } from '../types/terminal';

export const terminalUsbOption = {
    id: MONIEPOINT_TERMINAL_USB_ID,
    title: 'USB Connected Terminal',
    description: '',
};

export class TerminalService {
    constructor(private readonly db: AppDatabase) {
        this.db = db;
    }

    async fetchAndBulkUpsert() {
        await retrieveFullPaginatedData<Terminal>(
            REGISTERS_API_URL.REGISTER.GET_ASSIGNED_TERMINALS,
            {},
            async (response) => await this.bulkUpsert(response),
        );
    }

    async bulkUpsert(terminals: Terminal[]) {
        await this.db.terminals.bulkPut(terminals);
    }

    async getAll(searchTerm?: string) {
        const data = await this.db.terminals.toArray();

        if (!searchTerm) {
            return data;
        }

        const searchLower = searchTerm.toLowerCase();

        return data.filter(({ accountName, accountNumber, serialNumber }) => {
            return (
                accountName?.toLowerCase().includes(searchLower) ||
                accountNumber?.toLowerCase().includes(searchLower) ||
                serialNumber.toLowerCase().includes(searchLower)
            );
        });
    }

    async disconnect(serialNumber: string) {
        return this.db.terminals.delete(serialNumber);
    }

    async getTerminalOptions() {
        const data = await this.db.terminals.toArray();

        const apiTerminals = data.map((terminal) => ({
            id: terminal.serialNumber,
            title: `${terminal.accountName} - ${terminal.accountNumber}`,
            description: terminal.serialNumber,
            accountName: terminal.accountName ?? '',
            accountNumber: terminal.accountNumber ?? '',
            serialNumber: terminal.serialNumber ?? '',
            terminalId: terminal.terminalId,
        }));

        return apiTerminals;
    }
}
